<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    class="svg-icon"
  >
    <g :fill="color" fill-rule="nonzero">
      <path
        d="M13.333 8c.053 0 .105.006.157.019l.041.01.025.01c.025.008.05.018.073.03l.02.01.058.035c.034.024.067.05.098.081l-.057-.05c.015.012.03.024.043.037l.014.013.014.015.036.042c.011.013.021.027.03.041.013.019.025.038.036.058l.01.02c.012.024.022.048.03.073l.01.025.01.04c.005.02.008.037.011.056v.003l.008.099v4c0 .368-.298.666-.667.666-.368 0-.666-.298-.666-.666l-.001-2.391-3.528 3.529c-.234.234-.6.257-.86.07l-.083-.07c-.26-.26-.26-.683 0-.943l3.528-3.529h-2.39c-.334 0-.611-.246-.66-.568l-.006-.098c0-.369.298-.667.666-.667z"
      />
      <path
        d="M2.565 7.992l-.055-.01-.041-.012-.025-.008-.073-.03-.02-.011-.058-.035c-.034-.024-.067-.05-.098-.081l.057.05c-.015-.012-.03-.024-.043-.037l-.014-.013-.014-.015-.036-.042c-.011-.013-.021-.027-.03-.041-.013-.019-.025-.038-.036-.058l-.01-.02c-.012-.024-.022-.048-.03-.073l-.01-.025-.01-.04C2.006 7.437 2 7.385 2 7.332v-4c0-.368.298-.666.667-.666.368 0 .666.298.666.666v2.39l3.529-3.528c.234-.234.6-.257.86-.07l.083.07c.26.26.26.683 0 .943L4.276 6.666h2.39c.335 0 .612.247.66.569l.007.098c0 .369-.298.667-.666.667h-4l-.102-.008z"
      />
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-transaction",
  components: {},
})
export class IconTransaction extends Vue {
  @Prop({ default: 26 }) public size!: number;
  @Prop({ default: "#ffffff" }) public color!: string;

  constructor() {
    super();
  }
}
export default IconTransaction;
</script>
